import { useEffect } from 'react';
import { weddingConfig } from '@/data/weddingConfig';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Keeps the document title and meta tags in sync with the SEO values
 * defined in `weddingConfig.ts`. The static `index.html` provides the
 * initial crawler-visible defaults; this keeps the in-browser values
 * consistent with the same configuration.
 */
export default function Seo() {
  useEffect(() => {
    const { seo } = weddingConfig;
    document.title = seo.pageTitle;
    setMeta('name', 'description', seo.metaDescription);
    setMeta('property', 'og:title', seo.ogTitle);
    setMeta('property', 'og:description', seo.ogDescription);
    setMeta('property', 'og:image', seo.ogImage);
  }, []);

  return null;
}